import React from 'react';
import type { EmployeeHierarchyNode, EmployeeHierarchyPerson } from '../types';

export const OrgChartPersonCard: React.FC<{
  person: EmployeeHierarchyPerson;
  variant: 'default' | 'focus';
  onOpenProfile: (id: number) => void;
}> = ({ person, variant, onOpenProfile }) => (
  <button
    type="button"
    onClick={() => onOpenProfile(person.id)}
    className={`text-left rounded-lg border px-3 py-2 min-w-[10rem] max-w-[14rem] transition-shadow hover:shadow-md ${
      variant === 'focus'
        ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-400 ring-offset-1'
        : 'border-neutral-200 bg-white hover:border-neutral-300'
    }`}
  >
    <div className={`text-sm font-semibold ${variant === 'focus' ? 'text-blue-900' : 'text-neutral-900'}`}>
      {person.firstName} {person.lastName}
    </div>
    {person.mainPositionTitle ? (
      <div className="text-xs text-neutral-600 mt-0.5 line-clamp-2">{person.mainPositionTitle}</div>
    ) : (
      <div className="text-xs text-neutral-400 mt-0.5">—</div>
    )}
    <div className="text-[11px] text-blue-600 mt-1">View profile</div>
  </button>
);

export const OrgChartBranch: React.FC<{
  node: EmployeeHierarchyNode;
  onOpenProfile: (id: number) => void;
}> = ({ node, onOpenProfile }) => {
  const children = node.children && node.children.length > 0 ? node.children : [];
  return (
    <div className="flex flex-col items-center">
      <OrgChartPersonCard person={node} variant="default" onOpenProfile={onOpenProfile} />
      {children.length > 0 && (
        <>
          <div className="h-3 w-px bg-neutral-300 shrink-0" aria-hidden />
          <div className="flex flex-row flex-wrap justify-center gap-4 items-start pt-1">
            {children.map((c) => (
              <OrgChartBranch key={c.id} node={c} onOpenProfile={onOpenProfile} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};
